import { apiRequest } from '../../../api/client';
import type { DashboardMetrics } from '../../../api/types';

// PARA-106, AC-7.
export async function fetchDashboardMetrics(): Promise<DashboardMetrics> {
  return apiRequest<DashboardMetrics>('/admin/metrics');
}
